import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

import { MarketCreators, resetMarketLikeList } from 'redux/modules/market';
import { getUserId } from 'components/pages/market/home/MarketHome';

import BackLinkIcon from 'assets/icons/left_arrow.svg';
import theme from 'styles/theme';
import useScroll from 'hooks/common/useScroll';

const MarketLikeList = () => {
   const FETCH_SIZE = 5;

   const [marketItems, setMarketItems] = useState([]);
   const isScrollBottom = useScroll();
   const [isEndFetch, setIsEndFetch] = useState(false);
   const [page, setPage] = useState(0);
   const marketState = useSelector(state => state.market);
   const { likeList: newLikeList } = marketState;

   const navigate = useNavigate();
   const dispatch = useDispatch();
   const callFetchLikeList = _page =>
      dispatch(MarketCreators.fetchLikeList({ userId: getUserId(), page: _page }));
   const resetLikeList = () => {
      dispatch(resetMarketLikeList());
   };

   const resetAllState = () => {
      setIsEndFetch(false);
      setPage(0);
      setMarketItems([]);
   };

   useEffect(() => {
      callFetchLikeList(0);
      return () => {
         resetLikeList();
         resetAllState();
      };
   }, []);

   useEffect(() => {
      if (!newLikeList || newLikeList?.length <= 0) return;
      if (newLikeList.length < FETCH_SIZE) setIsEndFetch(true);
      setMarketItems([...marketItems, ...newLikeList]);
      setPage(page + 1);
   }, [newLikeList]);

   useEffect(() => {
      if (isScrollBottom && !isEndFetch) {
         callFetchLikeList(page);
      }
   }, [isScrollBottom]);

   const onNavigateToDetail = id => {
      navigate(`/market/${id}`);
   };

   return (
      <>
         <HeaderWrapper>
            <img src={BackLinkIcon} alt="Back Link button" onClick={() => navigate(-1)} />
            <HeaderTitle>도매상 찜 목록</HeaderTitle>
         </HeaderWrapper>
         <ListWrapper>
            {marketItems?.map((item, index) => {
               return (
                  <>
                     <MarketItemWrapper
                        key={index}
                        onClick={() => onNavigateToDetail(item.whole_id)}
                     >
                        <MarketImage src={item.whole_img} />
                        <MarketInfoWrap>
                           <PlaceText>{item.market_type}</PlaceText>
                           <MarketName>{item.whole_name}</MarketName>
                           <Description>{item.whole_loc}</Description>
                           <TagsWrap>
                              {item.items_on_sale.map((tag, index) => {
                                 return <Chip key={`${index}-${tag}`}>{tag}</Chip>;
                              })}
                           </TagsWrap>
                        </MarketInfoWrap>
                     </MarketItemWrapper>
                  </>
               );
            })}
         </ListWrapper>
      </>
   );
};

export default MarketLikeList;

//common
export const Row = styled.div`
   display: flex;
   flex-direction: row;
   align-items: center;
`;
export const Column = styled.div`
   display: flex;
   flex-direction: column;
`;
export const Text = styled.p``;
export const Button = styled.button``;
//

const HeaderWrapper = styled.div`
   position: relative;
   top: 0;
   left: 0;
   padding: 12px 16px;
   text-align: center;

   img {
      max-width: 24px;
      position: absolute;
      left: 16px;
      cursor: pointer;
   }
`;

const HeaderTitle = styled.h2`
   font-size: 1.125rem;
   font-weight: bold;
`;

//
const MarketItemWrapper = styled(Row)`
   cursor: pointer;
   user-select: none;
   position: relative;
   margin: 0px 16px;
   border: 1px solid #f1f3f5;
   box-shadow: 3px 3px 20px rgba(34, 37, 41, 0.05);
   border-radius: 8px;
`;

const MarketImage = styled.img`
   aspect-ratio: 1;
   width: 40%;
   object-fit: cover;
   border-top-left-radius: 8px;
   border-bottom-left-radius: 8px;
`;

const ListWrapper = styled.div`
   display: flex;
   flex-direction: column;
   gap: 12px;
`;

const MarketInfoWrap = styled(Column)`
   box-sizing: border-box;
   width: 60%;
   justify-content: center;
   padding: 0px 8px 0px 16px;
`;

const PlaceText = styled(Text)`
   font-weight: 400;
   font-size: 12px;
   line-height: 20px;
   color: ${theme.color.gray700};
   margin-bottom: 2px;
`;

const MarketName = styled(Text)`
   font-weight: 700;
   font-size: 14px;
   line-height: 20px;
   margin-bottom: 4px;
`;

const Description = styled(Text)`
   font-weight: 400;
   font-size: 12px;
   line-height: 20px;
   color: ${theme.color.gray600};
   margin-bottom: 8px;
`;

const TagsWrap = styled(Row)`
   column-gap: 14px;
   row-gap: 6px;
   overflow-x: scroll;
   -ms-overflow-style: none;
   scrollbar-width: none;
   &::-webkit-scrollbar {
      display: none;
   }
`;
export const Chip = styled.div`
   background-color: #fff8f0;
   border-radius: 4px;
   font-weight: 400;
   font-size: 12px;
   line-height: 20px;
   color: ${theme.color.orange};
   padding: 0px 6px;
   white-space: nowrap;
`;
